export const fathercolumn = [
  {
    id: 1,
    key: "维度",
    name: "维度",
  },
  {
    id: 2,
    key: "基础数据",
    name: "基础数据",
    fixed: true,
    width: 400,
    children: [
      {
        id: 0,
        key: "installs",
        name: "总新增",
        sort: true,
        point: 0,
        width: 100,
        sortMethod: (a, b) => sortColumn(a, b, "installs"),
        show: true,
        // fixed: true,
        fatherid: 2,
      },
      {
        id: 1,
        key: "arpu",
        name: "arpu",
        // sort: true,
        point: 0,
        width: 100,
        // sortMethod: (a, b) => sortColumn(a, b, "arpu"),
        show: true,
        fixed: true,
        fatherid: 2,
      },
      {
        id: 2,
        key: "estimateTimes",
        name: "预估倍数",
        // sort: true,
        fixed: true,
        point: 0,
        width: 100,
        // sortMethod: (a, b) => sortColumn(a, b, "estimateTimes"),
        show: true,
        fatherid: 2,
      },
      {
        id: 3,
        key: "popCost",
        name: "推广单价",
        // sort: true,
        point: 0,
        fixed: true,
        width: 100,
        // sortMethod: (a, b) => sortColumn(a, b, "popCost"),
        show: true,
        fatherid: 2,
      },
    ],
  },
  {
    id: 3,
    key: "用户价值",
    name: "用户价值",
    children: [
      {
        id: 4,
        key: "userValue1",
        name: "终身价值(经验值)",
        // sort: true,

        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue1"),
        show: true,
        fatherid: 3,
      },
      {
        id: 98,
        key: "userValue7",
        name: "7日用户价值",
        // sort: true,
        point: 0,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue7"),
        show: true,
        copy: true,
        fatherid: 3,
      },
      {
        id: 99,
        key: "userValue14",
        name: "14日用户价值",
        // sort: true,
        point: 0,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue14"),
        show: true,
        copy: true,
        fatherid: 3,
      },
      {
        id: 100,
        key: "userValue30",
        name: "30日用户价值",
        // sort: true,
        point: 0,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue30"),
        show: true,
        copy: true,
        fatherid: 3,
      },
      {
        id: 101,
        key: "userValue60",
        name: "60日用户价值",
        // sort: true,
        point: 0,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue60"),
        show: true,
        copy: true,
        fatherid: 3,
      },
      {
        id: 5,
        key: "userValue90",
        name: "90日用户价值",
        // sort: true,
        point: 0,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue90"),
        show: true,
        copy: true,
        fatherid: 3,
      },
      {
        id: 102,
        key: "userValue120",
        name: "120日用户价值",
        // sort: true,
        point: 0,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue120"),
        show: true,
        copy: true,
        fatherid: 3,
      },
      {
        id: 103,
        key: "userValue150",
        name: "150日用户价值",
        // sort: true,
        point: 0,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue150"),
        show: true,
        copy: true,
        fatherid: 3,
      },
      {
        id: 6,
        key: "userValue180",
        name: "180日用户价值",
        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue180"),
        show: true,
        fatherid: 3,
      },
      {
        id: 104,
        key: "userValue240",
        name: "240日用户价值",
        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue240"),
        show: true,
        fatherid: 3,
      },
      {
        id: 105,
        key: "userValue300",
        name: "300日用户价值",
        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue300"),
        show: true,
        fatherid: 3,
      },
      {
        id: 106,
        key: "userValue360",
        name: "360日用户价值",
        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "userValue360"),
        show: true,
        fatherid: 3,
      },
    ],
  },
  {
    id: 323243,
    key: "前期LT计算",
    name: "前期LT计算",
    children: [
      {
        id: 1000,
        key: "retention7LT",
        name: "7日LT",
        // sort: true,
        // percent: "%",
        // sortMethod: (a, b) => sortColumn(a, b, "retention7LT"),
        show: true,
        fatherid: 7,
      },
      {
        id: 1001,
        key: "retention14LT",
        name: "14日LT",
        // sort: true,
        // percent: "%",
        // sortMethod: (a, b) => sortColumn(a, b, "retention14LT"),
        show: true,
        fatherid: 7,
      },
    ],
  },
  {
    id: 7,
    key: "28日预估",
    name: "28日预估",
    children: [
      {
        id: 20,
        key: "p28_retentionDay30",
        name: "30日LT",
        // sort: true,
        // percent: "%",
        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay30"),
        show: true,
        fatherid: 7,
      },
      {
        id: 1002,
        key: "p28_retentionDay60",
        name: "60日LT",
        // sort: true,
        // percent: "%",
        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay60"),
        show: true,
        fatherid: 7,
      },
      {
        id: 21,
        key: "p28_retentionDay90",
        name: "90日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay90"),
        show: true,
        fatherid: 7,
      },
      {
        id: 1003,
        key: "p28_retentionDay120",
        name: "120日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay120"),
        show: true,
        fatherid: 7,
      },
      {
        id: 1004,
        key: "p28_retentionDay150",
        name: "150日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay150"),
        show: true,
        fatherid: 7,
      },
      {
        id: 22,
        key: "p28_retentionDay180",
        name: "180日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay180"),
        show: true,
        fatherid: 7,
      },
      {
        id: 1005,
        key: "p28_retentionDay240",
        name: "240日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay240"),
        show: true,
        fatherid: 7,
      },
      {
        id: 1005,
        key: "p28_retentionDay300",
        name: "300日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay300"),
        show: true,
        fatherid: 7,
      },
      {
        id: 22,
        key: "p28_retentionDay360",
        name: "360日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p28_retentionDay360"),
        show: true,
        fatherid: 7,
      },
    ],
  },
  {
    id: 6,
    key: "21日预估",
    name: "21日预估",
    children: [
      {
        id: 16,
        key: "p21_retentionDay30",
        name: "30日LT",
        // percent: "%",
        // sort: true,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p21_retentionDay30"),
        show: true,
        fatherid: 6,
      },
      {
        id: 17,
        key: "p21_retentionDay90",
        name: "90日LT",
        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p21_retentionDay90"),
        fatherid: 6,
      },
      {
        id: 18,
        key: "p21_retentionDay180",
        name: "180日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p21_retentionDay180"),
        show: true,
        fatherid: 6,
      },
      {
        id: 19,
        key: "p21_retentionDay360",
        name: "360日LT",
        // sort: true,
        point: 2,

        // sortMethod: (a, b) => sortColumn(a, b, "p21_retentionDay360"),
        show: true,
        fatherid: 6,
      },
    ],
  },
  {
    id: 5,
    key: "14日预估",
    name: "14日预估",
    children: [
      {
        id: 12,
        key: "p14_retentionDay30",
        name: "30日LT",
        // percent: "%",
        // sort: true,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p14_retentionDay30"),
        show: true,
        fatherid: 5,
      },
      {
        id: 13,
        key: "p14_retentionDay90",
        name: "90日LT",

        // sort: true,
        point: 2,
        width: 190,
        // sortMethod: (a, b) => sortColumn(a, b, "p14_retentionDay90"),
        show: true,
        copy: true,
        fatherid: 5,
      },
      {
        id: 14,
        key: "p14_retentionDay180",
        name: "180日LT",

        // sort: true,
        point: 2,
        width: 190,
        // sortMethod: (a, b) => sortColumn(a, b, "p14_retentionDay180"),
        show: true,
        copy: true,
        fatherid: 5,
      },
      {
        id: 15,
        key: "p14_retentionDay360",
        name: "360日LT",

        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p14_retentionDay360"),
        show: true,
        fatherid: 5,
      },
    ],
  },
  {
    id: 4,
    key: "7日预估",
    name: "7日预估",
    children: [
      {
        id: 8,
        key: "p7_retentionDay30",
        name: "30日LT",
        // percent: "%",
        // sort: true,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p7_retentionDay30"),
        show: true,
        fatherid: 4,
      },
      {
        id: 9,
        key: "p7_retentionDay90",
        name: "90日LT",

        // sort: true,
        point: 3,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p7_retentionDay90"),
        show: true,
        fatherid: 4,
      },
      {
        id: 10,
        key: "p7_retentionDay180",
        name: "180日LT",

        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p7_retentionDay180"),
        show: true,
        fatherid: 4,
      },
      {
        id: 11,
        key: "p7_retentionDay360",
        name: "360日LT",

        // sort: true,
        point: 2,
        width: 150,
        // sortMethod: (a, b) => sortColumn(a, b, "p7_retentionDay360"),
        show: true,
        fatherid: 4,
      },
    ],
  },
];
function sortColumn(a, b, key) {
  if (!a[key] && !b[key]) {
    return -1;
  } else if (!a[key] && b[key]) {
    return -1;
  } else if (a[key] && !b[key]) {
    return 1;
  }
  return a[key] - b[key] >= 0 ? 1 : -1;
}
